import React, { Component } from "react";
import { browserHistory } from 'react-router';
import axios from "axios";
import ParticipantControls from "./ParticipantControls";
import ParticipantStream from "./ParticipantStream";
import LiveParticipants from "./LiveParticipants";
import LeaveSession from "./LeaveSession";
import ParticipantsStats from "./ParticipantsStats";
import Reactions from "./Reactions";
import CurrentActivity from "./CurrentActivity";
import FooterActivity from "./FooterActivity";
import ActivityMenu from "./ActivityMenu";
import ZoomedPart from "./ZoomedPart";
import StreamNotification from "./StreamNotification";
import ActivityVideo from "./ActivityVideo";
import ChatContainer from "./ChatContainer";
import SupportContainer from '../home/SupportContainer';
import StreamingController from "../../streaming/StreamingController";
import RTM from "../../streaming/RTM";
import $ from 'jquery';
import Language from '../../services/contentData';
import ZoomNotes from "./ZoomNotes";
import playerFunctions from "../../utils/playerFunctions";
import FmPlayer from "./FmPlayer";
import OndemandPlayer from "./OndemandPlayer";
import MemberFitnessScript from "./MemberFitnessScript";
import classnames from "classnames";

class Participant extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			supportPageName: 'Guest',
			supportPageApi: '/guest',
			userTypeFaqs: JSON.parse(localStorage.getItem('userData')).userType,
			sessionData: {},
			leaveSession: false,
			chatCount: 0,
			rightMenuOpen: false,
			participantStatsOpen: false,
			openReactions: false,
			activityListOpen: false,
			openMyStream: true,
			openParticipantList: false,
			chatOpen: false,
			showNotification: false,
			notificationText: '',
			openActivityVideo: false,
			videoURL: '',
			liveParticipantUsers: [],
			openFmsNote: false,
			participantNotes: [],
			choosenNoteNum: 0,
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			isPlayingFM: false,
			setupStepName: '',
			watchAppPopupShown: false,
			shownWatchAppScreen: 1,
			roomSetupStep: 1,
			roomSetupTitle: 'Augmented Reality Requirements',
			roomSetupText: '<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>',
			roomSetupTitleNames: ['Augmented Reality Requirements', 'Stand in the marked area', 'Capturing', 'Done', 'Done'],
			roomSetupTextNames: ['<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>', '', '', '', '', ''],
			roomSetupButtonText: 'Continue',
			roomSetupSecondButton: '',
			roomSetupImageNames: ['', '', 'room_setup_loader', 'done_check', 'done_check', 'room_setup_loader'],
			roomSetupButtonTextNames: ['Continue', 'Skip', '', '', '', ''],
			roomSetupImage: '',
			innerHold: false,
			innerHoldSteps: [false, false, true, true, true, true],
			allCameraPermissionsTurnedOff: false,
			dontHaveAnyCam: false,
			showContinueButton: false,
			boxJumpWidth: 14,
			boxJumpHeight: 14,
			boxingCirclePosition: 1,
			cameraSelect: 0,
			showMemerFitnessScript: true,
			hiddenCaluclatingAR: true,
			dontShowInfo: "Don't show this again",
			recalibrationPopup: false,
			showOndemandError: false,
		}
		
		RTM.getInstance().registerHandler(this.RTMCallback.bind(this));
		this.attendanceInterval = null;
		window['updateStateFromChild'] = this.updateStateFromChild;
		window['updateLiveParticipants'] = this.updateLiveParticipants;
		this.playerFunctions = new playerFunctions();
		window['playerFunctions'] = this.playerFunctions;
		window['leaveSession'] = this.leaveSession;
		window['streamingPage'] = true;
		this.clickedOnSkip = false;
		window.roomSetupNextStep = this.roomSetupNextStepInSession;
		window.callTiltMessage = this.callTiltMessageInSession;
		window.callMediaTiltInSession = this.callMediaTiltInSession;
		window.showSkipAndTryAgain = this.showSkipAndTryAgain;
		window.clearTryAgain = this.clearTryAgain;
		window.showHideRoomSetup = this.showHideRoomSetup;
		window.hideMemberFitnessScript = this.hideMemberFitnessScript;
		window.calculatingAR = this.calculatingAR;
		window.disableCalculatingAR = this.disableCalculatingAR;
		window.startWatchTimeInterval = this.startWatchTimeInterval;
		window.clearViewInterval = this.clearViewInterval;
		window['showMemerFitnessScript'] = true;
		window['stopFmAtEndOfOnDemand'] = this.stopFmAtEndOfOnDemand;
		this.currentViewId = 0;
		this.onDemandWatchInterval = null;
		this.watchTimeDuration = 0;
		this.currentWatchTime = 0;
		this.clickedOnFirstSkip = false;
	}
 
	componentDidMount(){
		window.showCameraPopup = this.showCameraPopup;
		if ( localStorage.getItem('userData') ) 
			{
				var mainData = JSON.parse(localStorage.getItem('userData'));
				this.setState({sessionData: mainData.sessionData});
				this.attendanceInterval = setInterval(function(){
					if ( !window['countTimeSession'] ) { window['countTimeSession'] = 0; }
					window['countTimeSession']++;
					if ( window['countTimeSession'] == 30 )
						{
							var postData = {'duration_session': window['countTimeSession']};
							axios.defaults.headers.common['Authorization'] = mainData.token;
							axios.post(process.env.REACT_APP_API_URL +'/api/v1/session/'+mainData.sessionData.id+'/sessionattendtime', postData).then(res => {
								
							}).catch(err =>{ });   
							
							window['countTimeSession'] = 1;
						}
				}, 1000);
				
				var activity = mainData.sessionData.scriptDetail;
				for ( var i = 0; i < activity.length; i++ )
					{
						for ( var a = 0; a < activity[i].attribute.length; a++ )
							{
								if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
									{
										if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
											{
												window['isFoundParEquipment'] = true;
											}
									}
							}
					}
			}
		
		StreamingController();
		window['sendBoxInfo']();
		window['getSessionNotes']();
			
		if ( this.state.currentUserData.sessionData.replayClassId > 0 )
			{
				console.log('checkForFmStart');
				this.checkForFm();
			}
			
		if ( this.state.currentUserData.sessionData.ondemandId > 0 )
			{
				this.getCurrentView();
			}
		
		if ( window['participantRejoined'] && window['resetWhiteDraw'+this.state.currentUserData.id] )
			{
				window['participantRejoined'] = true;
				window['resetWhiteDraw'+this.state.currentUserData.id](this.state.currentUserData.id);
			}

		setTimeout(function(){
			if ( window['checkUnreadMessages'] )
				{
					window['checkUnreadMessages']();
				}
		},1000);
	}
	
	componentWillUnmount(){
		clearInterval(this.attendanceInterval);
		clearInterval(window['switchStreamsInterval']);
		window['switchStreamsInterval'] = null;
		clearInterval(window['mainIntervalWorkout']);
		window['mainIntervalWorkout'] = null;
	}
	
	RTMCallback = (payload) => {
		console.log('PAYLOAD---', payload);
		var mainthis = this;
		var hostFullName = JSON.parse(localStorage.getItem('userData')).sessionData.hostFirstName + ' ' + JSON.parse(localStorage.getItem('userData')).sessionData.hostLastName;
		if ( payload.code === 306 )
			{
				$('.main_loader').attr({'style':'display:flex'});
				this.showNotification(hostFullName+' ended Class.');
				setTimeout(function(){ 
					mainthis.hideNotification();
					mainthis.leaveSession();
				}, 3000);
				
				if ( localStorage.getItem('groupClass') !== null )
					{
						var sendData = JSON.parse(localStorage.getItem('groupClass'));
						let token = JSON.parse(localStorage.getItem('userData')).token;
						axios.defaults.headers.common['Authorization'] = token;
						axios.post(process.env.REACT_APP_API_URL+'/api/v1/programs/classCompleted', sendData).then(res => {
						}).catch(err =>{ });   
					}
			}
			
		if ( payload.code === 51 )
			{
				if ( payload.logout ) 
					{
						this.showNotification(hostFullName+' ejected you from Class.');
					}
				else
					{
						this.showNotification('Multiple Device Login.');
					}
				
				setTimeout(function(){ 
					mainthis.hideNotification();
					mainthis.leaveSession();
				}, 3000);
			}
			
		if ( payload.code === 290 && !this.state.currentUserData.sessionData.ondemandId )
			{
				this.showNotification('You have been unmuted by '+hostFullName);
				setTimeout(function(){ 
					mainthis.hideNotification();
				}, 3000);
			}
			
		if ( payload.code === 291 && !this.state.currentUserData.sessionData.ondemandId )
			{
				this.showNotification('You have been muted by '+hostFullName);
				setTimeout(function(){ 
					mainthis.hideNotification();
				}, 3000);
			}
			
		if ( payload.code === 503 && !this.state.currentUserData.sessionData.ondemandId )
			{
				this.showNotification(hostFullName+' joined session.');
				setTimeout(function(){ 
					mainthis.hideNotification();
				}, 3000);
			}
			
		if ( payload.code === 504 && !this.state.currentUserData.sessionData.ondemandId )
			{
				this.showNotification(hostFullName+' is offline.');
				setTimeout(function(){ 
					mainthis.hideNotification();
				}, 3000);
			}
			
		if ( payload.code === 302 )
			{
				var enabledVar = 'enabled';
				if ( payload.state == 0 ) { enabledVar = 'disabled'; }
				
				this.showNotification(hostFullName+' has '+enabledVar+' member video list.');
				setTimeout(function(){ 
					mainthis.hideNotification();
				}, 3000);
			}
			
		if ( payload.code === 75 )
			{
				if ( payload.func == 'play' )
					{
						let name = '';
						
						if ( payload.name )
							{
								name = payload.name;
							}
						
						this.playerFunctions.playPlayer(payload.param, name);
						this.setState({isPlayingFM: true}, ()=>{
							$('.participant_header').addClass('fmControlAlign');
						});
					}
					
				if ( payload.func == 'stop' )
					{
						this.playerFunctions.stopPlayer();
						this.setState({isPlayingFM: false}, ()=>{
							$('.participant_header').removeClass('fmControlAlign');
						});
						window['reduceHostVolume'](75);
					}
					
				if ( payload.func == 'mute' )
					{
						var bool = payload.param == "true" ? true : false;
						this.playerFunctions.setMuted(bool);
						if ( bool == false )
							{
								if ( window['adjustFmVolume'] )
									{
										window['adjustFmVolume']();
									}
							}
						window['showHideVolume'](bool);
					}
			}
	}
	
	stopFmAtEndOfOnDemand=()=>{
		this.playerFunctions.stopPlayer();
		this.setState({isPlayingFM: false}, ()=>{
			$('.participant_header').removeClass('fmControlAlign');
		});
		window['reduceHostVolume'](75);
	}
	
	checkForFm=()=>{
		var sessionStations = this.state.currentUserData.sessionData.sessionStations;
		if ( sessionStations.length > 0 ) {
			var currentStationId = sessionStations[0].stationId;
			var currentName = sessionStations[0].stationName;

			this.playerFunctions.playPlayer(currentStationId, currentName);
			this.setState({isPlayingFM: true}, ()=>{
				$('.participant_header').addClass('fmControlAlign');
			});
		}
	}
	
	updateStateFromChild=(state)=>{
		this.setState(state);
	}
	
	showNotification=(info)=>{
		this.setState({showNotification: true, notificationText: info});
	}
	
	hideNotification=()=>{
		this.setState({showNotification: false, notificationText: ''});
	}
	
	leaveSession=()=>{
		if ( this.state.currentUserData.sessionData.replayClassId > 0 )
			{
				var videoReplay = document.getElementById("replayClassVideo");
				videoReplay.pause();
				videoReplay.src = '';
				this.playerFunctions.stopPlayer();
				this.setState({isPlayingFM: false}, ()=>{
					$('.participant_header').removeClass('fmControlAlign');
				});
				window['reduceHostVolume'](75);
			}
			
		window['hideMemberOnVirtual'] = undefined;
		if ( window['eventHR'] )
			{
				window['eventHR'].close();
				window['eventHR'] = false;
			}
		window.logout();
		window['hideFeedFmStatus'] = false;
		window['participantRejoin'] = true;
		window['participantRejoined'] = true;
		window['mediaPipeFirstTime'] = false;
		window['streamingPage'] = false;
		window['guestUser'] = false;
		window['updateFlutterCanvas'] = false;
		window['virtualScriptStarted'] = false;
		window['roomSetDone'] = false;
		
		if ( window.soundPlay ) { window.soundPlay.stopAudio(); }
		if ( window['userWhiteboard'][this.state.currentUserData.id] ) 
			{ 
				window.removeWhiteboard();
			}
			
		if ( window['eventCurrent'] && window['eventCurrent']['adminReportsOngoingSessions'] )
			{
				window['eventCurrent']['adminReportsOngoingSessions'].close();
				window['eventCurrent']['adminReportsOngoingSessions'] = false;
			}
		
		if ( document.getElementById('replayClassVideo') ) { document.getElementById('replayClassVideo').remove(); }
			
		var postData = { duration_session: window['countTimeSession'] ? window['countTimeSession'] : 0 }
		let token = JSON.parse(localStorage.getItem('userData')).token;
		axios.defaults.headers.common['Authorization'] = token;
		$('.main_loader').attr({'style':'display:flex'});
		axios.post(process.env.REACT_APP_API_URL+'/api/v1/session/'+JSON.parse(localStorage.getItem('userData')).sessionData.id+'/completedguest', postData).then(res => {
			$('.main_loader').hide();
			this.checkUpcomingSession();
			window['countTimeSession'] = 0;
			clearInterval(this.attendanceInterval);
			if ( this.state.currentUserData.sessionData.ondemandId > 0 )
				{
					if ( window['disableViewInterval'] ) { window['disableViewInterval'](); }
				}
		}).catch(err =>{ });   
	}
	
	checkUpcomingSession = () => {
		this.playerFunctions.stopPlayer();
		
		const userData = {
			userId: JSON.parse(localStorage.getItem('userData')).id,
			auth: JSON.parse(localStorage.getItem('userData')).token
		};
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/loginNative", userData).then(res => {
			res.data.responseData.unmuteAllEnabled = false;
            localStorage.setItem("userData", JSON.stringify(res.data.responseData));
            this.handleUpcomingSessions();
         }).catch(err => { this.handleCloseWindow(); });
	}
	
	handleUpcomingSessions() {
		window.$('#multi-device-login-alert').modal('hide');
		
		var localstoragedata = JSON.parse(localStorage.getItem('userData'));
		if ( localstoragedata !== null )
			{
				if ( localstoragedata.showNextPast == 'past' ) 
					{
						this.handleCloseWindow();
					}
				else
					{
						if ( localstoragedata.sessionData != undefined )
							{
								window.onbeforeunload = null;
								this.props.history.push('/home');
							} 
						else 
							{
								this.handleCloseWindow();
							}
					}
			}
		else
			{
				this.handleCloseWindow();
			}
	}
	
	handleCloseWindow = () => {
		
		if ( window['openOndemandFromBookmark'] )
			{
				window['openOndemandFromBookmark'] = false;
				this.props.history.push('/home#myScheduleAndBookmark');
			}
		else 
			{
				window['openOndemandFromBookmark'] = false;
				this.props.history.push('/home');
			}			
		
	}
	
	raiseHand=()=>{
		window.handRaiseClient();
	}
	
	playActivityVideo=(url)=>{
		if ( !this.state.openActivityVideo )
			{
				this.setState({videoURL: url, openActivityVideo: true, openReactions: false});
			}
		else
			{
				this.setState({openActivityVideo: false}, () => {this.setState({videoURL: url, openActivityVideo: true, openReactions: false})});
			}
	}
	
	hideCurrentModal = (ell) => {
		window.$(ell).modal('hide');
	}
	
	updateLiveParticipants = (data) => {
		this.setState({
			liveParticipantUsers: data
		});
	}
	
	roomSetupNextStepInSession=()=>{
		
		let currentRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupTitle = this.state.roomSetupTitle;
		let nextRoomSetupText = this.state.roomSetupText;
		let nextRoomSetupButtonText = this.state.roomSetupButtonText;
		let nextRoomSetupImage = this.state.roomSetupImage;
		let innerHoldVar = this.state.innerHold;
		console.log('roomSetupNextStepInSessionBefore', nextRoomSetupTitle);
		
		if ( currentRoomSetupStep == 1 )
			{	
				//athis.preStreamingSetup();
				//window['startRoomSetup']();
				window.soundPlay.stopAudio();
				window.soundPlay.playAudio('ContinuePlayRoomSetup');
				var mainthis = this;
				var roomSetupTimer = 10;
				
				var roomSetupInterval = setInterval(function(){
					if ( mainthis.clickedOnFirstSkip ) { $('#partBigCounter').addClass('d-none'); roomSetupTimer = 1; }
						roomSetupTimer--;
						
						if ( roomSetupTimer <= 5 && !mainthis.clickedOnFirstSkip )
							{
								$('#partCounterNum').text(roomSetupTimer);
								$('#partBigCounter').removeClass('d-none');
							}
							
						if ( roomSetupTimer == 0 )
							{
								window['shownCameraPopup'] = false;
								window['redoRoomSetup']();
								window['resetRoomSetup']();
								clearInterval(roomSetupInterval);
								$('#partBigCounter').addClass('d-none');
								if ( mainthis.clickedOnFirstSkip && window.skipMediaPipeCount ) { window.skipMediaPipeCount(); }
							}
				}, 1000);
			}
		
		if ( this.state.roomSetupButtonText == 'Skip' && this.state.roomSetupSecondButton == 'Retry' )
			{
				window['userWhiteboard'][this.state.currentUserData.id].trackerActions.disableMediaPipe();
				this.showHideRoomSetup(true);
			}
		
		if ( !this.clickedOnFirstSkip && this.state.roomSetupTitle == 'Stand in the marked area' )
			{
				this.clickedOnFirstSkip = true;
				window['alreadyClickedOnSkip'] = true;
			}
		
		if ( !this.clickedOnSkip && ( this.state.roomSetupTitle == 'Tilt your camera up' || this.state.roomSetupTitle == 'Tilt your camera down') )
			{
				this.clickedOnSkip = true;
				console.log(this.state.roomSetupTitle, 'roomSetupTitle');
				window.finishMediaPipeCalculationInnit();
				this.clearTryAgain();
			
				this.setState({
					roomSetupSecondButton: ''
				});
				
				setTimeout(function(){
					window['usingPose'] = true;
					
				}, 3000);
			}
			
		if ( currentRoomSetupStep < this.state.roomSetupTitleNames.length )
			{	
				nextRoomSetupStep = currentRoomSetupStep+1;
				nextRoomSetupTitle = this.state.roomSetupTitleNames[currentRoomSetupStep];
				nextRoomSetupText = this.state.roomSetupTextNames[currentRoomSetupStep];
				nextRoomSetupButtonText = this.state.roomSetupButtonTextNames[currentRoomSetupStep];
				nextRoomSetupImage = this.state.roomSetupImageNames[currentRoomSetupStep];
				innerHoldVar = this.state.innerHoldSteps[currentRoomSetupStep];
			}
			
		if ( nextRoomSetupStep == this.state.roomSetupTitleNames.length )
			{
				this.showHideRoomSetup(false);
			}
			
		console.log('roomSetupNextStepInSessionAfter', nextRoomSetupTitle);
		this.setState({
			roomSetupStep: nextRoomSetupStep,
			roomSetupTitle: nextRoomSetupTitle,
			roomSetupText: nextRoomSetupText,
			roomSetupButtonText: nextRoomSetupButtonText,
			roomSetupImage: nextRoomSetupImage,
			innerHold: innerHoldVar
		});
	}

	callTiltMessageInSession=(innerText)=>{
		this.setState({
			roomSetupTitle: innerText,
			roomSetupText: '',
			roomSetupButtonText: 'Skip',
			roomSetupImage: '',
			innerHold: ''
		});
	}
	
	showCameraPopup = () => {
		window['shownCameraPopup'] = true;
		
		this.setState({
			setupStepName: 'Room Setup',
			hideRoomSetupMessage: false,
			roomSetupStep: 1,
			roomSetupTitle: 'Augmented Reality Requirements',
			roomSetupText: '<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>',
			roomSetupButtonText: 'Continue',
			roomSetupSecondButton: '',
			roomSetupImage: ''
		});
	}
	
	showSkipAndRetry=()=>{
		this.setState({
			roomSetupButtonText: 'Skip',
			roomSetupSecondButton: 'Retry'
		});
	}
	
	callMediaTiltInSession=()=>{
		window['usingPose'] = true;
	}

	tryAgainTilt=()=>{
		window['startTiltTimeout']();
		this.setState({
			roomSetupSecondButton: ''
		});
	}
	
	clearTryAgain=()=>{
		window['usingPose'] = true;
		this.setState({
			roomSetupSecondButton: ''
		});
	}
	
	retryRoomSetup=()=>{
		window.retryRoomSetup(parseInt(this.state.currentUserData.id));
		
		this.setState({
			roomSetupSecondButton: ''
		});
	}
	
	showSkipAndTryAgain=()=>{
		window['usingPose'] = false;
		this.setState({
			roomSetupButtonText: 'Skip',
			roomSetupSecondButton: 'Try Again'
		});
	}
	
	showHideRoomSetup=(hideMessage)=>{
		this.setState({
			hideRoomSetupMessage: hideMessage,
			roomSetupSecondButton: ''
		});
	}
	
	hideMemberFitnessScript=()=>{
		this.setState({
			showMemerFitnessScript: false,
		},()=>{ window['showMemerFitnessScript'] = false; })
	}
	
	calculatingAR=()=>{
		window['calculatingCalledAR'] = true;
		this.setState({
			hiddenCaluclatingAR: false
		},()=>{ $('.left_stream').addClass('opacity-zero'); });
	}
	
	disableCalculatingAR=()=>{
		this.setState({
			hiddenCaluclatingAR: true
		},()=>{ $('.left_stream').removeClass('opacity-zero'); });
	}
	
	showRecalibrationPopup=()=>{
		this.setState({
			recalibrationPopup: true
		});
	}
	
	dontShowMessageAgain=()=>{
		this.disableCalculatingAR();
		this.recalibrationPopupAction(true);
	}
	
	recalibrationPopupAction = (mod) => {
		if ( mod )
			{
				var recalibrationObject = JSON.stringify({'sessionId': this.state.currentUserData.sessionData.id, 'value': true});
				localStorage.setItem('recalibrationHidden', recalibrationObject);
				window['disableRecabToggle']();
			}
		else
			{
				var recalibrationObject = JSON.stringify({'sessionId': this.state.currentUserData.sessionData.id, 'value': false});
				localStorage.setItem('recalibrationHidden', recalibrationObject);
			}
		
		this.setState({
			recalibrationPopup: false
		});
	}
	
	getCurrentView=()=>{
		let token = JSON.parse(localStorage.getItem('userData')).token;
		let mainthis = this;
		axios.defaults.headers.common['Authorization'] = token;
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/getCurrentView", {'sessionId': this.state.currentUserData.sessionData.ondemandId, 'userId': this.state.currentUserData.id})
          .then(res => {
			  var viewData = res.data.responseData[0];
               console.log(res.data.responseData[0], 'getCurrentView');
			   mainthis.currentViewId = viewData.id;
          }).catch(err => {}
      );
	}
	
	startWatchTimeInterval=()=>{
		let mainthis = this;
		this.onDemandWatchInterval = setInterval(function(){
			if ( !mainthis.watchTimeDuration ) { mainthis.watchTimeDuration = 0; }
			mainthis.watchTimeDuration++;
			mainthis.currentWatchTime++;
			if ( mainthis.watchTimeDuration == 10 )
				{
					console.log('startWatchTimeInterval');
					
					mainthis.insertCurrentWatchTime();
					
					mainthis.watchTimeDuration = 0;
				}
		}, 1000);
	}
	
	clearViewInterval=()=>{
		clearInterval(this.onDemandWatchInterval);
		this.watchTimeDuration = 0;
		window['viewIntervalStarted'] = false;
		this.insertCurrentWatchTime();
	}
	
	insertCurrentWatchTime=()=>{
		let token = JSON.parse(localStorage.getItem('userData')).token;
			axios.defaults.headers.common['Authorization'] = token;
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/updateOndemandWatchTime", {'currentViewId': this.currentViewId, 'watchTime': this.currentWatchTime})
			  .then(res => {
				 
			  }).catch(err => {}
		);
	}
	
	ondemandErrorMsg=()=>{
		console.log('----show error message---');
		this.setState({
			showOndemandError: true,
		});
	}
	
	render() {
		return (
			<div className={"" + ( this.state.rightMenuOpen ? "move_support_right" : "" ) } >
				<div className={"participant_streaming_container" + ( this.state.rightMenuOpen ? " container_right_menu" : "" ) }>
					<div className="top_room_setup_bar"></div>
					<div className="bottom_room_setup_bar"></div>
					<div id="toolTipContainer"></div>
					<header className={"participant_header " } >
						<div className="session_data_container">
							<div className="channelimg" style={{backgroundImage: "url('" + this.state.sessionData.channelImage + "')"}}></div>
							<div className="sess_name">{this.state.sessionData.name}</div>
							<div className="host_container">By {this.state.sessionData.hostFirstName} {this.state.sessionData.hostLastName}</div>
							{ !this.state.currentUserData.sessionData.ondemandId &&	
								<div className="dspl_inl" >
									<div className="online_icon" id="onlineicon"></div>
									<div className="online_icon offline_icon  d-none" id="offlineicon"></div>
									<div className="online_text" id="onlinetext">ONLINE</div>
								</div>	
							}
						</div>
						<div className="networkMsgHolder d-none">Poor/Unstable Network</div>
						<div className="virtualDisabledMsg d-none">Continue Your Workout Without A/R</div>
						<ParticipantControls 
							updateStateFromChild={this.updateStateFromChild} 
							raiseHand={this.raiseHand} 
							chatOpen={this.state.chatOpen} 
							participantStatsOpen={this.state.participantStatsOpen}
							openReactions={this.state.openReactions}
							isPlayingFM = {this.state.isPlayingFM}
						></ParticipantControls>
						{ this.state.isPlayingFM &&
							<div className={"memberSide_fm_holder " + ( window['hideFeedFmStatus'] ? "d-none" : "" ) } >
								<div className="participant_player">
									<FmPlayer></FmPlayer>
								</div>
							</div>
						}
						{ this.state.currentUserData.sessionData.ondemandId > 0 &&
							<OndemandPlayer
							ondemandErrorMsg={this.ondemandErrorMsg}
							></OndemandPlayer>
						}
					</header>
					<ZoomedPart></ZoomedPart>
					<div className="main_view_participant">
						<div className={classnames("start_room_button_holder", { 'd-none': this.state.setupStepName != 'Room Setup'})}>
							<div className={classnames("room_setup_message_hold inside_session_button", {'d-none': this.state.hideRoomSetupMessage, 'room_setup_message_small': this.state.roomSetupStep != 1, "room_setup_inner_holder": this.state.innerHold})}>
								<div className={classnames("", {'d-none': this.state.roomSetupImage == ''})}>
									<div className={classnames("room_setup_loader", {'d-none': this.state.roomSetupImage != 'room_setup_loader'})}>
									  <div className="room_setup_loader_inner"></div>
									</div>
									<div className={classnames("done_check", {'d-none': this.state.roomSetupImage != 'done_check'})}>
										<svg className="checkmark room_setup_checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> 
									</div>
								</div>
								<div className={classnames("room_setup_message_title", {'d-none': this.state.roomSetupTitle == '', 'room_setup_smaller_title': this.state.roomSetupStep == 1})}>{this.state.roomSetupTitle}</div>
								<div className={classnames("room_setup_message", {'d-none': this.state.roomSetupText == '', 'room_setup_smaller_text': this.state.roomSetupStep == 1})} dangerouslySetInnerHTML={{__html: this.state.roomSetupText}}></div>
								<div className={classnames("room_setup_message_button_hold", {'d-none': this.state.roomSetupButtonText == '' && this.state.roomSetupSecondButton == ''})}>
									{this.state.roomSetupSecondButton == 'Try Again' &&
										<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.tryAgainTilt}>
											{this.state.roomSetupSecondButton}
										</div>
									}
									<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupButtonText == '', 'room_setup_button_small': this.state.roomSetupSecondButton !== ''})} onClick={this.roomSetupNextStepInSession}>
										{this.state.roomSetupButtonText}
									</div>
									{this.state.roomSetupSecondButton == 'Retry' &&
										<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.retryRoomSetup}>
											{this.state.roomSetupSecondButton}
										</div>
									}
								</div>
							</div>
						</div>
						<div id="showCalculatingAR" className={classnames("start_room_button_holder", { 'd-none': this.state.hiddenCaluclatingAR })}>
							<div className="room_setup_message_hold inside_session_button room_setup_message_small">
								<div className="calibration_ar_text">Calibrating</div>
								<div className="calibration_ar_text d-inline-block">AR</div>
								<div className="room_setup_loader">
								  <div className="room_setup_loader_inner"></div>
								</div>
								<div className="calibration_ar_text out_of_frame">Did you step out of frame?</div>
								<div className="calibration_ar_text out_of_frame dont_show_message pointer" onClick={ () => this.dontShowMessageAgain()}>{this.state.dontShowInfo}</div>
							</div>
						</div>
						<div id="virtualmsg" className="screen_popup px-4 py-3 bg-grayy rounded text-white d-none"></div>
						<div className="left_stream">
							<CurrentActivity></CurrentActivity>
							<FooterActivity updateStateFromChild={this.updateStateFromChild} activityListOpen={this.state.activityListOpen}></FooterActivity>						
						</div>
						<div className="right_stream">
							<ParticipantStream openMyStream={this.state.openMyStream} updateStateFromChild={this.updateStateFromChild} showRecalibrationPopup={this.showRecalibrationPopup} recalibrationPopupAction={this.recalibrationPopupAction}></ParticipantStream>
							<div className={(this.state.openMyStream ? "opened_my_stream" : "" )}>
								{ !this.state.currentUserData.sessionData.ondemandId && 
									<LiveParticipants openParticipantList={this.state.openParticipantList} updateStateFromChild={this.updateStateFromChild}></LiveParticipants>
								}								
							</div>
						</div>
					</div>
					<footer className="footer_streaming">
						<div className="footerPaddingHolder d-none">
							{ this.state.currentUserData.isMarketplaceChannel != 1 &&
								<div className="recording_on_participant d-none" id="record_info">
									<div className="rec_icon"></div>
									<div className="rec_text">Recording to the cloud</div>
								</div>
							}
							<div className="playlist_container d-none" id="playlist_participant">
								<div className="playlist_content">
									<div className="song_animation"></div>
									<div className="song_cont">
										<div className="songname" id="songname"></div>
										<div className="songartist" id="songartist"></div>
									</div>
								</div>
							</div>
						</div>
						{ this.state.currentUserData.isMarketplaceChannel == 1 && this.state.showMemerFitnessScript &&
							<MemberFitnessScript
							state={this.state}
							updateStateFromChild={this.updateStateFromChild}
							playActivityVideo={this.playActivityVideo}
							></MemberFitnessScript>
						}
					</footer>
					<div className="main_stream" id="host_stream">
					</div>
					<div id="canvasWrap" className="canvasHold centerCanvas d-none"> 
						<span className="canvas-line-icon position-absolute d-none" id="canvasLine"></span><span className="canvas-square-icon position-absolute d-none" id="canvasSquare"></span><span className="canvas-circle-icon position-absolute d-none" id="canvasCircle"></span><span className="canvas-close-icon position-absolute d-none"></span>
						<canvas className="canvasDraw" id="sessionCanvas" width="1280" height="720"></canvas><canvas className="canvasGrid canvasImage" id="imageCanvas" width="1280" height="720"></canvas><canvas className="canvasImage" id="bufferCanvas" width="640" height="360"></canvas>
						<div className="canvasDot" id="editDot"></div>
					</div>
					<div id="canvasUser" className="canvasHold centerCanvas d-none"></div>
					{ this.state.currentUserData.sessionData.replayClassId == 0 && !this.state.currentUserData.sessionData.ondemandId && <div className="hostNoVideoIcon" id="hostNoVideo"></div> }
					<div className="main_stream d-none" id="injected_video">
						<video className="participant_injected" src="" id="injected_activity" type="video/mp4" autoplay></video>
					</div>
					{ this.state.currentUserData.isMarketplaceChannel != 1 &&
						<div className="pipHostVideo" id="injected_pip">
							<div className="videoHolderCoverPip" id="injected_pip_video"></div>
						</div>
					}
					<div className={(!this.state.openReactions ? "d-none" : "" )}>
						<Reactions updateStateFromChild={this.updateStateFromChild}></Reactions>
					</div>
					<div className="particlecontainer"></div>
				</div>
				{ this.state.participantStatsOpen &&
					<div className="left_container">
						<ParticipantsStats state={this.state} updateStateFromChild={this.updateStateFromChild}></ParticipantsStats>
					</div>
				}
				<div className={(!this.state.activityListOpen ? "d-none" : "left_container" )}>
					<ActivityMenu 
					state={this.state}
					updateStateFromChild={this.updateStateFromChild} 
					playActivityVideo={this.playActivityVideo}>
					</ActivityMenu>
				</div>
				<div id="chat_menu" className={(!this.state.chatOpen ? "d-none" : "chat_container" )}>
					<ChatContainer updateStateFromChild={this.updateStateFromChild}></ChatContainer>
				</div>
				{ this.state.showNotification && 
					<StreamNotification notificationText={this.state.notificationText}></StreamNotification>
				}
				{ this.state.openActivityVideo &&
					<ActivityVideo videoURL={this.state.videoURL} updateStateFromChild={this.updateStateFromChild}></ActivityVideo>
				}
				{ this.state.leaveSession &&
					<LeaveSession sessionName={this.state.sessionData.name} updateStateFromChild={this.updateStateFromChild} leaveSession={this.leaveSession}></LeaveSession>
				}
				<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
				
				<div className="modal pr-0 fade show onboarding-modal" id="tracker-error" data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog small_width modal-dialog-centered ">
						<div className="modal-content bg-transparent">
							<div className="modal-body px-4 py-5 bg-grayy radius-10"> 
								<div className="modal-header justify-content-center px-0 border-bottm">
									<h5 className="modal-title white_hdng">Virtual Equipment Error</h5>
								</div>
								<div>
									<p className="text-white font-20 mb-4">Oops, there was an error with Virtual Equipment. If you would like to use Virtual Equipment in this Class, please logout and quit the Virdio app then log back in. If you would like to continue without Virtual Equipment, press OK.</p>
								</div>
							</div>
							<div className="text-center mt-4">
								<button type="button" className="done mt-0 mx-2" onClick={ () => this.hideCurrentModal('#tracker-error')}>OK</button>
							</div>
						</div>
					</div>
				</div>
				
				
				{ this.state.showOndemandError &&
					<div className="waiting_lounge_popup videoErrorZIndex">
						<div className="recalibration_inner">
							<div className="recalibration_title">Video Error</div>
							<div className="recalibration_title recalibration_inner_text">Oops, something went wrong. Please leave class and join again.</div>
							<div className="recal_buttons_hold">
								<div className="join_streaming ml0 wl_popup_left_button recab_buttons" onClick={ () => this.setState({showOndemandError: false})}>Close</div>
							</div>
						</div>
					</div>
				}
				
				<div className="main_loader">
				  <div className="main_loader_inner_new_design"></div>
				</div>
				
				{ this.state.recalibrationPopup &&
					<div className="waiting_lounge_popup" id="recalibrationPopup">
						<div className="recalibration_inner">
							<div className="recalibration_title">Disable Recalibration?</div>
							<div className="recalibration_title recalibration_inner_text">You will not be able to use Virtual<br></br>equipment if you move out of frame</div>
							<div className="recal_buttons_hold">
								<div className="join_streaming ml0 wl_popup_left_button recab_buttons" onClick={ () => this.recalibrationPopupAction(false)}>Cancel</div>
								<div className="join_streaming ml0 wl_popup_right_button recab_buttons"onClick={ () => this.recalibrationPopupAction(true)}>Yes</div>
							</div>
						</div>
					</div>
				}
				
				<div id="multi-device-login-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog modal-confirm modal-dialog-centered">
					  <div className="modal-content bg-grayy px-4 position-relative radius-10">
						<div className="modal-header px-0 justify-content-center border-bottm">
						  <h5 className="modal-title white_hdng">{Language.multipleDevice.heading}</h5>
						</div>
						<div className="modal-body">
						  <div>
							<p className="text-white font-17 mb-5">{Language.multipleDevice.msg}</p>
						  </div>
						</div>
						<div className="ok_btn_cont w-100 text-center">
						  <button className="ok-btn">{Language.multipleDevice.btn}</button>
						</div>
					  </div>
					</div>
				</div>	
				{this.state.openFmsNote &&
					<ZoomNotes
						state={this.state}
						updateStateFromChild={this.updateStateFromChild}
					></ZoomNotes>
				}
				<div className="bigCountShow d-none" id="partBigCounter">
						<div className="countNumD2C" id="partCounterNum">0</div>
					</div>
			</div>
	)}
}
export default Participant;
